<div id="Login_section" *ngIf="isVendorIdStep">
  <section class="singUp-area section-py-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="singUp-wrap">
            <h2 class="title">Vendor Profile Setup</h2>
            <p>
              Hey there! Ready to set up your profile?<br />
              Just enter your Vendor ID below and get started. Don’t have your
              vendor ID? Please contact the
              {{ utilityService.clientDisplayName }} to receive it.
            </p>
            <div class="account__divider"></div>
            <form [formGroup]="idForm" novalidate class="account__form">
              <div class="form-grp">
                <label class="inline"
                  >Vendor ID# <span class="text-danger">*</span></label
                >
                <div
                  class="form-group"
                  [ngClass]="{
                    'has-error': !idf['vendorId'].valid && submitted
                  }"
                >
                  <input
                    type="text"
                    class="form-control"
                    formControlName="vendorId"
                  />
                </div>
              </div>

              <button class="btn btn-two arrow-btn" (click)="onSubmit()">
                Submit<img
                  src="assets/img/icons/right_arrow.svg"
                  alt="img"
                  class="injectable"
                />
              </button>
            </form>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>

<div id="Login_section" *ngIf="!isVendorIdStep">
  <section class="singUp-area section-py-120">
    <div class="container">
      <div class="row justify-content-center">
        <div class="col-xl-6 col-lg-8">
          <div class="singUp-wrap">
            <h2 class="title">Vendor Profile Setup</h2>
            <p>
              Almost Done!<br />
              Just enter your email and password below.
            </p>
            <div class="account__divider"></div>
            <form novalidate [formGroup]="form" class="account__form">
              <div class="form-grp">
                <label class="inline"
                  >Email <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{ 'has-error ': !f['Email'].valid && submitted }"
                >
                  <input
                    type="email"
                    class="form-control"
                    formControlName="Email"
                    placeholder="Enter your email"
                  />
                </div>
              </div>

              <div class="form-grp">
                <label class="inline"
                  >Password <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{
                    'has-error ':
                      (!f['Password'].valid && submitted) || passwordMismatch
                  }"
                >
                  <div class="input-group">
                    <input
                      [type]="isPasswordVisible ? 'text' : 'password'"
                      class="form-control"
                      formControlName="Password"
                      placeholder="Enter your password"
                    />
                  </div>
                </div>
                <small
                  [ngClass]="{
                    'text-danger': f['Password'].errors?.['minlength'],
                    'text-muted': !f['Password'].errors?.['minlength']
                  }"
                >
                  Password must be at least 8 characters long
                </small>
                <small
                  [ngClass]="{
                    'text-danger': f['Password'].errors?.['pattern'],
                    'text-muted': !f['Password'].errors?.['pattern']
                  }"
                >
                  Password must contain both letters and numbers
                </small>
              </div>

              <div class="form-grp">
                <label class="inline"
                  >Confirm Password <span class="text-danger">*</span></label
                >
                <div
                  class="form-grp"
                  [ngClass]="{
                    'has-error ':
                      (!f['ConfirmPassword'].valid && submitted) ||
                      passwordMismatch
                  }"
                >
                  <div class="input-group">
                    <input
                      [type]="isPasswordVisible ? 'text' : 'Password'"
                      class="form-control"
                      formControlName="ConfirmPassword"
                      placeholder="Enter your confirm password"
                    />
                  </div>
                </div>
              </div>

              <div *ngIf="passwordMismatch" class="text-danger">
                Password and Confirm Password do not match.
              </div>

              <button class="btn btn-two arrow-btn" (click)="onsignup()">
                Sign Up<img
                  src="assets/img/icons/right_arrow.svg"
                  alt="img"
                  class="injectable"
                />
              </button>
            </form>
            <div class="account__switch">
              <p>Already have an account?<a href="/login">LogIn</a></p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
</div>
